import { chatService } from "../../services/resources/chatService";
import { openNotification } from "../Notification";
import {
  marcarMensagemFixada,
  mesclarConversa,
  mesclarFixada,
  removerFixada,
} from "./chatFormat";

export async function carregarFixadas(codigo, setFixadas) {
  const { data } = await chatService.listarFixadas(codigo);
  setFixadas(Array.isArray(data) ? data : []);
}

export async function fixarMensagemChat(codigoConversa, mensagem, setFixadas, setMensagens) {
  if (!codigoConversa || !mensagem?.codigo) return;
  try {
    const { data } = await chatService.fixarMensagem(codigoConversa, mensagem.codigo);
    setFixadas((lista) => mesclarFixada(lista, data));
    setMensagens((lista) => marcarMensagemFixada(lista, mensagem.codigo, true));
  } catch (error) {
    openNotification(
      "error",
      <strong>Não foi possível fixar a mensagem</strong>,
      error?.response?.data?.userMessage || error?.response?.data?.detail
    );
  }
}

export async function desafixarMensagemChat(codigoConversa, mensagem, setFixadas, setMensagens) {
  if (!codigoConversa || !mensagem?.codigo) return;
  try {
    await chatService.desafixarMensagem(codigoConversa, mensagem.codigo);
    setFixadas((lista) => removerFixada(lista, mensagem));
    setMensagens((lista) => marcarMensagemFixada(lista, mensagem.codigo, false));
  } catch (error) {
    openNotification(
      "error",
      <strong>Não foi possível desafixar a mensagem</strong>,
      error?.response?.data?.userMessage || error?.response?.data?.detail
    );
  }
}

export async function fixarConversaChat(conversa, setConversas) {
  if (!conversa?.codigo) return;
  try {
    const { data } = await chatService.fixarConversa(conversa.codigo);
    setConversas((lista) => mesclarConversa(lista, { ...conversa, ...data, fixada: true }));
  } catch (error) {
    openNotification(
      "error",
      <strong>Não foi possível fixar a conversa</strong>,
      error?.response?.data?.userMessage || error?.response?.data?.detail
    );
  }
}

export async function desafixarConversaChat(conversa, setConversas) {
  if (!conversa?.codigo) return;
  try {
    const { data } = await chatService.desafixarConversa(conversa.codigo);
    setConversas((lista) => mesclarConversa(lista, { ...conversa, ...data, fixada: false }));
  } catch (error) {
    openNotification(
      "error",
      <strong>Não foi possível desafixar a conversa</strong>,
      error?.response?.data?.userMessage || error?.response?.data?.detail
    );
  }
}
